module.exports = __webpack_public_path__ + "img/26.68fa5f5f.jpg";